import React, { useState } from "react";
import {
  Box,
  Grid,
  Checkbox,
  Typography,
  IconButton,
  Popover,
  Divider,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import StatusChip from "../StatusChip";
import CommentIcon from "@mui/icons-material/Comment";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import LeadRating from "../LeadRating";
import {
  formatPhoneForWhatsapp,
  isValidIsraeliPhone,
} from "../../utils/convertInternationalPhoneFormat";

const Lead = ({
  lead,
  onClick,
  onStatusChange,
  onMark,
  isChecked,
  onDeleteClick,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };
  return (
    <Box
      p={2}
      bgcolor="white"
      borderRadius={2}
      boxShadow={1}
      mb={2}
      sx={{ "&:hover": { boxShadow: 3 } }}
    >
      {/* Top Info Row */}
      <Grid container spacing={2} columns={12} alignItems="flex-start" mb={1}>
        <Grid size={2}>
          <Box display={"flex"}>
            <Checkbox checked={isChecked} onClick={() => onMark(lead.id)} />
            <Typography
              variant="body1"
              onClick={onClick}
              sx={{
                "&:hover": {
                  cursor: "pointer",
                },
                color: "primary.main",
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              {lead.name}
            </Typography>
          </Box>
        </Grid>

        <Grid size={1}>
          {lead.comments && (
            <>
              <IconButton
                aria-describedby={lead.id}
                onClick={handleOpenPopover}
              >
                <CommentIcon />
              </IconButton>
              <Popover
                id={lead.id}
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={handleClosePopover}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
              >
                <Typography sx={{ p: 2 }}>{lead.comments}</Typography>
              </Popover>
            </>
          )}
        </Grid>
        <Grid size={1}>
          <StatusChip
            status={lead.status}
            onChange={(newStatus) => onStatusChange(lead.id, newStatus)}
          />
        </Grid>
        <Grid size={1} textAlign={"center"}>
          <LeadRating rating={lead.strength} readOnly size="small" />
        </Grid>
        <Grid size={1}>
          <Typography variant="body2">{lead.company}</Typography>
        </Grid>
        <Grid size={1}>
          <Typography variant="body2">{lead.phone}</Typography>
        </Grid>
        <Grid size={2}>
          <Typography variant="body2">{lead.email}</Typography>
        </Grid>
        <Grid size={2}>
          <Typography variant="body2">{lead.created_at}</Typography>
        </Grid>
      </Grid>
      <Divider />
      {/* Optional Footer Row */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mt={1}
      >
        <Typography variant="body2" color="text.secondary">
          Lead id: {lead.id}, Last contacted: {lead.lastContact || "Not yet"}
        </Typography>

        <Box display="flex" gap={1}>
          <IconButton size="small" onClick={onDeleteClick}>
            <DeleteForeverIcon />
          </IconButton>
          {isValidIsraeliPhone(lead.phone) && (
            <IconButton
              size="small"
              color="success"
              onClick={() => {
                const waNumber = formatPhoneForWhatsapp(lead.phone);
                if (waNumber) {
                  window.open(`https://wa.me/${waNumber}`, "_blank");
                } else {
                  alert("Invalid phone number for WhatsApp");
                }
              }}
            >
              <WhatsAppIcon />
            </IconButton>
          )}
          <IconButton
            size="small"
            onClick={(e) => {
              onClick();
            }}
          >
            <EditIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default Lead;
